import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Typography from '../Typography/Typography';

interface NavigationItem {
  label: string;
  path: string;
}

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navigationItems: NavigationItem[] = [
    {
      label: 'Dashboard',
      path: '/dashboard',
    },
    // {
    //   label: 'Analytics',
    //   path: '/analytics',
    // }
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="bg-[#1A1D44] border border-[#6E7087] rounded-full border-1 flex items-center">
      {navigationItems.map((item, index) => (
        <div
          key={item.path}
          className={`flex-1 cursor-pointer transition-all duration-300 ease-in-out ${
            isActive(item.path)
              ? 'bg-[#323458] rounded-full shadow-sm'
              : 'hover:bg-[#2A2A40] rounded-full'
          }`}
          onClick={() => handleNavigation(item.path)}
        >
          <div className={`px-4 py-2 text-center transition-all duration-300 ${
            isActive(item.path) ? 'text-white' : 'text-white/80 hover:text-white'
          }`}>
            <Typography 
              variant="h6" 
              className={`font-medium text-sm sm:text-base lg:text-lg transition-colors duration-300 ${
                isActive(item.path) ? 'text-white' : 'text-white/80'
              }`}
            >
              {item.label}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Navigation;
